// extracted by mini-css-extract-plugin
module.exports = {"tos":"_terms-and-conditions-styles-module--tos--10l9A"};